export const hasOnlySpaces = (str: string): boolean => Boolean(str.length && !Boolean(str.trim()))
